(() => {
    // Tabbed heading for the gift guide page (snippets/fh-gift-guide.liquid).
    // Each tab controls one of the sections directly after the tabs section, in order.
    class FhGiftGuideTabs extends HTMLElement {
        connectedCallback() {
            this.tabs = Array.from(this.querySelectorAll('[role="tab"]'))
            this.panels = []

            let section = this.closest('.shopify-section')
            const panelCount = Math.max(this.tabs.length, 1)
            for (let i = 0; i < panelCount && section; i++) {
                section = section.nextElementSibling
                if (section && section.classList.contains('shopify-section')) this.panels.push(section)
            }

            this.tabs.forEach((tab, index) => {
                const panel = this.panels[index]
                if (!panel) return
                tab.setAttribute('aria-controls', panel.id)
                panel.setAttribute('role', 'tabpanel')
                panel.setAttribute('aria-labelledby', tab.id)
                tab.addEventListener('click', () => this.select(index))
                tab.addEventListener('keydown', (evt) => this.handleKeydown(evt, index))
            })

            this.querySelectorAll('.fh-gg-tabs__arrow').forEach((button) => {
                button.addEventListener('click', () => this.scrollCarousel(button.name === 'next' ? 1 : -1))
            })

            this.hashChangeHandler = this.selectFromHash.bind(this)
            this.sectionSelectHandler = this.handleSectionSelect.bind(this)
            window.addEventListener('hashchange', this.hashChangeHandler)
            document.addEventListener('shopify:section:select', this.sectionSelectHandler)

            if (!this.selectFromHash()) this.select(0)
        }

        disconnectedCallback() {
            window.removeEventListener('hashchange', this.hashChangeHandler)
            document.removeEventListener('shopify:section:select', this.sectionSelectHandler)
        }

        select(index, focus = false) {
            if (!this.tabs.length) return
            this.activeIndex = index
            this.tabs.forEach((tab, i) => {
                const selected = i === index
                tab.setAttribute('aria-selected', selected)
                tab.setAttribute('tabindex', selected ? '0' : '-1')
                if (this.panels[i]) this.panels[i].hidden = !selected
            })
            if (focus) this.tabs[index].focus()
        }

        selectFromHash() {
            const index = this.tabs.findIndex((tab) => `#${tab.id}` === window.location.hash)
            if (index < 0) return false
            this.select(index)
            return true
        }

        handleKeydown(evt, index) {
            const keys = { ArrowRight: 1, ArrowLeft: -1 }
            if (!(evt.key in keys)) return
            evt.preventDefault()
            this.select((index + keys[evt.key] + this.tabs.length) % this.tabs.length, true)
        }

        // Keep the section being edited in the theme editor visible
        handleSectionSelect(evt) {
            const index = this.panels.findIndex((panel) => panel.id === `shopify-section-${evt.detail.sectionId}`)
            if (index > -1) this.select(index)
        }

        scrollCarousel(direction) {
            const panel = this.panels[this.activeIndex || 0]
            const slider = panel && panel.querySelector('.slider')
            if (!slider) return
            const item = slider.querySelector('.slider__item')
            const step = item ? item.getBoundingClientRect().width : slider.clientWidth
            slider.scrollBy({ left: direction * step * (document.dir === 'rtl' ? -1 : 1), behavior: 'smooth' })
        }
    }

    if (!customElements.get('fh-gift-guide-tabs')) customElements.define('fh-gift-guide-tabs', FhGiftGuideTabs)

    // Landing Page Menu links only support #anchors: a target id starting with "/" is used as a page link instead
    document.querySelectorAll('.lp-menu a[href^="#/"]').forEach((link) => {
        link.setAttribute('href', link.getAttribute('href').slice(1))
    })
})()
